import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#029f48',
        secondary: '#234025',
        accent: '#8c9eff',
        error: '#b71c1c',
        textBody: '#424540',
      },
    },
  },
});
